<template>
  <div>    
    <ToastAlert 
      :is-active="toastAlert" 
      :type="typeMsg" 
      :message="msg"
      @close="closeToast" 
    />
    
    <div class="sm:w-[760px] sm:mb-0 mb-16">
      <!-- Area/Metros Inputs -->
      <p class="text-lg font-medium text-black mb-4">Características</p>
      <div
        class="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-6"
      >
        <!-- Area total -->
        <div class="flex flex-1 justify-center items-center mt-0">
          <div class="flex-auto">
            <label
              for="constructed_metres"
              class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
            >Área total*</label>
            <input
              id="constructed_metres"
              v-model="constructed_metres_formatted"
              type="text"
              placeholder="Ingresa el número en m²"
              @input="formatNumberInput('constructed_metres', $event)"
              @blur="onBlurNumberInput('constructed_metres')"
              @focus="onFocusNumberInput('constructed_metres')"
              class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            />
          </div>
        </div>

        <!-- Metros construidos -->
        <div class="flex flex-1 justify-center items-center mt-5">
          <div class="flex-auto">
            <label
              for="meters_build"
              class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
            >Metros construidos*</label>
            <input
              id="meters_build"
              v-model="meters_build_formatted"
              type="text"
              placeholder="Ingresa el número en m²"
              @input="formatNumberInput('meters_build', $event)"
              @blur="onBlurNumberInput('meters_build')"
              @focus="onFocusNumberInput('meters_build')"
              class="bg-white h-11 border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            />
          </div>
        </div>
      </div>
      <!-- Caracteristicas counters -->
      <div
        class="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 mb-6"
      >
        <!-- Antigüedad -->
        <div 
          v-if=" ![ 30 ].includes( type_property_id ) "
          class="flex flex-1 justify-center items-start"
        >
          <div class="w-full">
            <NumberStepperComponent
              v-model="age"
              label="Antigüedad (años)"
            />
          </div>
        </div>
        <!-- Baños completos -->
        <div 
          v-if=" ![ 4, 6 ].includes( type_property_id ) " 
          class="flex flex-1 justify-center items-start"
        >
          <div class="w-full">
            <NumberStepperComponent
              v-model="bathrooms"
              label="Baños completos"
              :required="![8].includes(type_property_id)"
            />
          </div>
        </div>
        <!-- Medios baños -->
        <div 
          v-if=" ![ 3, 4, 6 ].includes( type_property_id ) " 
          class="flex flex-1 justify-center items-start"
        >
          <div class="w-full">
            <NumberStepperComponent
              v-model="half_bathrooms"
              label="Medios baños"
              :required="true"
            />
          </div>
        </div>
        <!-- Recámaras -->
        <div 
          v-if=" ![ 3, 4, 6, 8 ].includes( type_property_id ) "
          class="flex flex-1 justify-center items-start"
        >
          <div class="w-full">
            <NumberStepperComponent
              v-model="bedrooms"
              label="Recámaras"
              :required="true"
            />
          </div>
        </div>
        <!-- Pisos -->
        <div 
          v-if=" ![ 2, 4, 6, 8 ].includes( type_property_id ) " 
          class="flex flex-1 justify-center items-start"
        >
          <div class="w-full">
            <NumberStepperComponent
              v-model="floor"
              label="Pisos"
              :required="true"
            />
          </div>
        </div>
        <!-- Piso ubicacion -->
        <div 
          v-if=" ([ 2, 9 ].includes( type_property_id )) " 
          class="flex flex-1 justify-center items-start"
        >
          <div class="w-full">
            <NumberStepperComponent
              v-model="floor"
              label="Piso en el que se ubica"
              :required="true"
            />
          </div>
        </div>
        <!-- Estacionamientos -->
        <div 
          v-if=" ![ 4, 6 ].includes( type_property_id ) "
          class="flex flex-1 justify-center items-start"
        >      
          <div class="w-full">
            <NumberStepperComponent
              v-model="parking"
              label="Estacionamientos"
              :required="true"
            />
          </div>
        </div> 
      </div>

      <!--Caracteristicas-->
      <div class="mb-6">
        <FormCharacteristicsComponent 
          :property-id="propertyId" 
          section="characteristics"
          @trigger-update="handleUpdate"
        /> 
      </div>

      <!-- editor description  -->
      <div class="flex flex-col-1 mb-6">
        <div class="flex-auto">
          <label
            for="property_description"
            class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
          >
            Describe la propiedad*
          </label>
          <textarea
            id="property_description"
            v-model="property_description"
            rows="6"
            placeholder="Ingresa una descripción para tu propiedad"
            class="block p-2.5 w-full text-base text-custom_gray bg-white rounded-lg border border-gray-300 focus:ring-tuin-100 focus:border-tuin-100 transition-colors"
          ></textarea>
        </div>
      </div>

      <!-- editor characters  -->
      <div class="flex flex-col-1 mb-6">
        <div class="flex-auto">
          <label
            for="characteristics"
            class="block mb-2 text-sm font-medium text-custom_gray dark:text-white"
          >
            Características adicionales
          </label>
          <textarea
            id="characteristics"
            v-model="characteristics"
            rows="6"
            placeholder="Ingresa las características adicionales"
            class="block p-2.5 w-full text-base text-custom_gray bg-white rounded-lg border border-gray-300 focus:ring-tuin-100 focus:border-tuin-100 transition-colors"
          ></textarea>
        </div>
      </div>

      <!-- btn save -->
      <div class="hidden flex-col">
        <div class="flex flex-1 justify-end items-end mt-5">
          <button 
            class="w-full sm:w-auto px-5 py-2.5 rounded-lg text-sm font-medium text-white bg-tuin-100 hover:bg-tuin_hover transition-colors" 
            @click="save()"
          >
            Siguiente
          </button>
        </div>
      </div>
      <!-- btn save -->
    </div>
  </div>
</template>
<script setup>
    import { ref, computed, defineProps, watch, defineEmits } from "vue";
    import ToastAlert from "@/commond/ToastAlert.vue";
//    import { FwbButton } from "flowbite-vue";
    import axios from "axios";
    import { useStore } from "vuex";
    import FormCharacteristicsComponent from "@/components/properties/FormCharacteristicsComponent.vue";
    import NumberStepperComponent from "@/components/common/NumberStepperComponent.vue";
    import { usePropertySync } from "@/composables/usePropertySync";
    const store = useStore();
    let session = computed(() => store.getters.getUserSession);
    const {
      syncWithPropiedades: syncWithPropiedadesShared,
      syncWithEasyBroker: syncWithEasyBrokerShared,
    } = usePropertySync();
    
    const props = defineProps({
      resp: {
        type: Object,
        required: true,
        default: () => ({ property_name: '' })
      },
      propertyId: {
        type: Number,
        required: true,
        default: 0
      },
      isAvailable: {
        type: Boolean,
        default: false
      }
    });

    const emit = defineEmits(['triggerUpdate']);

    let toastAlert = ref(false);
    let typeMsg = ref("");
    let msg = ref("");

    // Form fields    
    let age                 = ref('');
    let bedrooms            = ref('');
    let bathrooms           = ref('');
    let parking             = ref('');
    let half_bathrooms      = ref('');
    let floor               = ref(0);
    let location_floor      = ref(0); 
    let constructed_metres  = ref(0);
    let meters_build        = ref(0);
    let property_description= ref("");
    let characteristics     = ref("");

    // Formatted display values for number inputs
    let constructed_metres_formatted = ref('');
    let meters_build_formatted = ref('');

    // Number formatting functions
    const formatNumber = (value) => {
      if (!value) return '';
      
      // Remove any existing commas and non-numeric characters except dots
      const numericValue = value.toString().replace(/[^\d.]/g, '');
      
      // Parse as float to handle decimals
      const num = parseFloat(numericValue);
      
      if (isNaN(num)) return '';
      
      // Format with commas and preserve up to 2 decimal places
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    };

    const formatNumberInput = (fieldName, event) => {
      const value = event.target.value;
      
      // Remove any non-numeric characters except dots and commas
      let cleanValue = value.replace(/[^\d.,]/g, '');
      
      // Remove existing commas for processing
      cleanValue = cleanValue.replace(/,/g, '');
      
      // Limit to 2 decimal places
      const parts = cleanValue.split('.');
      if (parts.length > 2) {
        cleanValue = parts[0] + '.' + parts[1];
      }
      if (parts[1] && parts[1].length > 2) {
        cleanValue = parts[0] + '.' + parts[1].substring(0, 2);
      }
      
      // Update the actual numeric value
      const numericValue = parseFloat(cleanValue) || 0;
      
      if (fieldName === 'constructed_metres') {
        constructed_metres.value = numericValue;
        constructed_metres_formatted.value = formatNumber(cleanValue);
      } else if (fieldName === 'meters_build') {
        meters_build.value = numericValue;
        meters_build_formatted.value = formatNumber(cleanValue);
      }
    };

    const onFocusNumberInput = (fieldName) => {
      // Show raw number when focused for easier editing
      if (fieldName === 'constructed_metres') {
        constructed_metres_formatted.value = constructed_metres.value ? constructed_metres.value.toString() : '';
      } else if (fieldName === 'meters_build') {
        meters_build_formatted.value = meters_build.value ? meters_build.value.toString() : '';
      }
    };

    const onBlurNumberInput = (fieldName) => {
      // Format with commas when user leaves the field
      if (fieldName === 'constructed_metres') {
        constructed_metres_formatted.value = formatNumber(constructed_metres.value);
      } else if (fieldName === 'meters_build') {
        meters_build_formatted.value = formatNumber(meters_build.value);
      }
    };

      //  Validaciones para 1	- Casa  
      //  Validaciones para 2	-	Departamento
      //  Validaciones para 3	-	Oficina
      //  Validaciones para 5	-	Consultorio
      //  Validaciones para 7	-	Local
      //  Validaciones para 8	-	Bodega
      //  Validaciones para 9	-	Desarrollo
  
    async function validationForm() {
      // Validación básica de campos requeridos independiente del tipo
      const requiredFields = [
        {
          value: constructed_metres.value,
          message: "Debes ingresar el área en metros"
        },
        {
          value: meters_build.value,
          message: "Debes ingresar los metros construidos"
        },
        {
          value: property_description.value,
          message: "Debes ingresar una descripción válida del inmueble (mínimo 2 palabras).",
          validate: (val) => {
            const trimmedValue = val ? val.trim() : '';
            return (
              trimmedValue &&
              trimmedValue !== "" &&
              trimmedValue.split(/\s+/).length >= 2
            );
          }
        }
      ];

      // Validación para propiedades residenciales y comerciales
      if ([1, 2, 5, 7, 9].includes(type_property_id.value)) {
        requiredFields.push(
          {
            value: bedrooms.value,
            message: "Debes ingresar cantidad de recámaras"
          },
          {
            value: bathrooms.value,
            message: "Debes ingresar cantidad de baños"
          },
          {
            value: half_bathrooms.value,
            message: "Debes ingresar cantidad de medios baños"
          },
          {
            value: parking.value,
            message: "Debes ingresar cantidad de estacionamientos"
          },
          {
            value: floor.value,
            message: "Debes ingresar cantidad de pisos"
          },
        );
      }

      // Validar cada campo requerido
      for (const field of requiredFields) {
        const isValid = field.validate ? 
          field.validate(field.value) : 
          field.value !== undefined && field.value !== '' && field.value !== null;

        if (!isValid) {
          return { 
            status: false, 
            message: field.message 
          };
        }
      }

      // Validaciones específicas por tipo de propiedad
      switch (type_property_id.value) {
        case 2: // Departamento
        case 9: // Desarrollo
          if (floor.value === undefined || floor.value === null || floor.value === '' || Number(floor.value) <= 0) {
            return {
              status: false,
              message: "Debes ingresar el piso en el que se ubica mayor que 0"
            };
          }
          break;
        
        case 3: // Oficina
        case 5: // Consultorio
        case 7: // Local
          if (!constructed_metres.value) {
            return {
              status: false,
              message: "Debes ingresar el área comercial en metros"
            };
          }
          break;

        case 4: // Terreno
        case 6: // Lote
          if (!constructed_metres.value || !meters_build.value) {
            return {
              status: false,
              message: "Debes ingresar las dimensiones del terreno"
            };
          }
          break;
      }

      return { status: true, message: 'Ok' };
}

async function save() {
  let is_valid = await validationForm();

  // For plain text, we can use the description directly as summary
  const formattedText = property_description.value ? property_description.value.trim() : '';
  console.log('----', formattedText);

  if (!is_valid['status']) {
    showToast('danger', is_valid['message']);
    return;
  }

  let post_params = {
    age:                      age.value,
    bedrooms:                 bedrooms.value,
    bathrooms:                bathrooms.value,
    parking:                  parking.value,
    half_bathrooms:           half_bathrooms.value,
    constructed_metres:      constructed_metres.value,
    meters_build:            meters_build.value,
    property_description:     property_description.value,
    summary:                  formattedText,
    characteristics:          characteristics.value,
    floor:                    floor.value,
    location_floor:           location_floor.value,
    type_property_id:         props.resp && props.resp.general ? props.resp.general.type_property_id : ''
  };

  let isUpdating = false;

  if (props.propertyId != 0) {
    post_params['property_id'] = props.propertyId;
    isUpdating = true;
  }

  let url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}/save_characteristics`;

  let options = {
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${session.value.token_api}`
    },
  };

  try {
    const response = await axios.post(url, post_params, options);

    if (response.status === 401) {
      console.log("Hay que sacarlo de la sesión");
    }

    if (response.status === 200) {
      showToast('success', response.data.message);
      emit('triggerUpdate', response.data.resp.id);

      // 🔄 Si es actualización, sincronizar con propiedades.com
      if (isUpdating && props.isAvailable) {
        await syncWithPropiedades(props.propertyId);
        await syncWithEasyBroker(props.propertyId);
      }
      return true;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    return false;
  }
}

async function syncWithPropiedades(propertyId) {
  return syncWithPropiedadesShared(propertyId);
}
async function syncWithEasyBroker(propertyId) {
  return syncWithEasyBrokerShared(propertyId, {
    endpoint: "editar",
    onSuccess: () => {
      showToast("success", "Propiedad sincronizada con EasyBroker");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    },
    onError: () => {
      showToast("error", "Error al sincronizar con EasyBroker");
    },
  });
}

    async function closeToast() {
      toastAlert.value = false;
      typeMsg.value = "";
      msg.value = "";
    }

    async function showToast(type, message){
      toastAlert.value = true;
      typeMsg.value = type;
      msg.value = message;

      setTimeout(() => {
        closeToast()
      }, 3000);
    }

    let type_property_id = ref(null);
    watch(      
      () => [props.resp.characters, props.resp] ,  
      async ([newVal, obj_resp]) => {
        type_property_id.value = obj_resp && obj_resp.general  ? obj_resp.general.type_property_id : 0;
        
        age.value                 = newVal && newVal.age                  != null ? newVal.age : '';
        bedrooms.value            = newVal && newVal.bedrooms             != null ? newVal.bedrooms : '';
        bathrooms.value           = newVal && newVal.bathrooms            != null ? newVal.bathrooms : '';
        half_bathrooms.value      = newVal && newVal.half_bathrooms       != null ? newVal.half_bathrooms : '';
        constructed_metres.value  = newVal && newVal.constructed_metres   != null ? newVal.constructed_metres : '';
        meters_build.value        = newVal && newVal.meters_build         != null ? newVal.meters_build : '';
        parking.value             = newVal && newVal.parking              != null ? newVal.parking : '';
        floor.value               = newVal && newVal.floor                != null ? newVal.floor : '';
        property_description.value= newVal && newVal.property_description != null ? newVal.property_description.replace(/<[^>]+>/g, '') : "";
        characteristics.value     = newVal && newVal.characteristics      != null ? newVal.characteristics.replace(/<[^>]+>/g, '') : ""; 
        
        // Initialize formatted values for number inputs
        constructed_metres_formatted.value = formatNumber(constructed_metres.value);
        meters_build_formatted.value = formatNumber(meters_build.value);
      },
      { immediate: true }
    );

async function handleUpdate(propertyId) {
  //console.log('[ACCORDION_DETAILS_UPDATE]', propertyId);
  emit('triggerUpdate', propertyId);
}

// Exponer el método save para que pueda ser llamado desde el componente padre
defineExpose({
  save
});
</script>

<style scoped>
/* Custom styles for the form */
</style>


